/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkerStatuses } from './worker-statuses';


export interface WorkerStatus { 
    name: WorkerStatuses;
    code: string;
}



